import React from 'react'
import AzureAD, { IAzureADProps } from 'react-aad-msal'

export const AzureAd = AzureAD as React.FunctionComponent<React.PropsWithChildren<IAzureADProps>>
